import React from 'react';

import { setEmailDatabase, setNameDatabase, trackSegmentUser } from '../redux/actions/UserActions';
import { showSubmitModal } from "../redux/actions/FlagActions";
import { trackSegmentBike } from "../redux/actions/BikeActions";

import LocalStorage from '../classes/LocalStorage';

import SearchService from '../classes/SearchService';

import axios from 'axios';

import 'react-responsive-modal/lib/react-responsive-modal.css';

import { connect } from 'react-redux';

import formatDate from '../functions/formatDate';

const searchService = new SearchService();
const localStorage = new LocalStorage();

class FormEmail extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            email: '',
            name: '',
            checked: true,
            id: 0
        };
    }

    // Save data to Segment / Drip after from submitting
    track = () => {

        // Child name
        const name = this.state.name;
        let isUniqueName = true;

        // Check if child already exist
        const childName = localStorage.get('gbChildName');

        // if not - save this name for Local storage for checking child name next time
        if (childName) {
            if (childName === name) {
                isUniqueName = false;
            } else {
                isUniqueName = true;
                localStorage.save('gbChildName', name);
            }
        } else {
            localStorage.save('gbChildName', name);
        }

        // Save number of child to Local storage. This keys uses in Drip
        // So, we can manipulate keys with unique child number, fe child_3_name, child_3_age etc.
        let childNum = localStorage.get('gbChild');
        if (isUniqueName) {
            if (childNum) {
                childNum = Number(localStorage.get('gbChild')) + 1;
            } else {
                childNum = 1;
            }
        }
        localStorage.save('gbChild', childNum);

        const { bikeDueDate, estimatedHeight, bike, date, user, params } = this.props;

        // Calculate bike after child will grow up
        const nextBike = searchService.getNext(this.props.bike);
        this.props.dispatch(setNameDatabase({ name }, childNum));

        const birthMonth = formatDate(date, true).month;
        const birthYear = formatDate(date, true).year;

        const birth = {
            birthYear,
            birthMonth
        };

        // If user agree with subscription (checkbox), we set Drip subscription
        const subscribtion = this.state.checked;

        // Track all data to Segment - Drip
        this.props.dispatch(trackSegmentUser({ user }, { name }, { date, birth }, childNum, { subscribtion }, { params }));
        this.props.dispatch(trackSegmentBike({ user }, { bike }, { nextBike }, { bikeDueDate }, { estimatedHeight }, childNum));
    }

    sendRequest = () => {

        const { user } = this.props;

        // Send request to server with current user ID
        axios.post(`/api/form/${user.id}`, { user },
            {
                headers: {
                    'Authorization': '2b0acef1d1672133533929d031f0b098088bbb72',
                    'Content-Type': 'application/json',
                }
            })
            .then(response => {
                console.log(response)
            })
            .catch(error => {
                console.log(error.response)
            });

    }

    onSubmit = event => {

        event.preventDefault();
        const { date } = this.props;

        if (!date) {
            document.querySelector('.react-date-picker__button').classList.add('error');
            return
        }

        // Save User email to database and show confirm modal
        this.props.dispatch(setEmailDatabase({ email: this.state.email }));
        this.props.dispatch(showSubmitModal({ showSubmit: true }));
        document.querySelector('.react-date-picker__button').classList.remove('error');

        // Track all events to segment and Drip
        this.track();

        // Send request to server, send email to user
        this.sendRequest();

        // Reset inputs states
        this.setState(() => {
            return {
                email: '',
                name: ''
            }
        })
    }

    onChange = event => {
        event.persist();
        this.setState(() => {
            return {
                [event.target.name]: event.target.value
            }
        })
    }

    // Checkbox with Ridesizer report
    onSetSubscription = () => {
        this.setState(() => {
            return {
                checked: !this.state.checked
            }
        })
    }

    render() {
        const { name, email, checked } = this.state;
        return (
            <form className="email-form" onSubmit={this.onSubmit}>
                <h3>Get a Full Growth Report!</h3>
                <p>See exactly how your child will grow into this bike and understand when they will outgrow it.</p>
                <div className="email-form-data">
                    <div className="input-email">
                        <input
                            className="input-email-value"
                            type="email"
                            name="email"
                            value={email}
                            onChange={this.onChange}
                            pattern="[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}"
                            placeholder='Enter Email'
                            required
                        />
                    </div>
                    <div className="input-child-name">
                        <input
                            className="input-child-name-value"
                            type="text"
                            name="name"
                            value={name}
                            onChange={this.onChange}
                            placeholder="Child’s Name/Nickname"
                            required />

                        <button className="submit-gtm">{this.props.submitText || 'Submit'}</button>
                    </div>
                    <div className="checkbox-container">
                        <div className="checkbox-custom">
                            <input onChange={this.onSetSubscription} type="checkbox" id="subscription" defaultChecked={checked} />
                            <div className="checkbox">
                                <svg viewBox="0 0 24 24">
                                    <path d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" />
                                </svg>
                            </div>
                        </div>
                        <label htmlFor="subscription">I would like to learn more about Guardian Bikes in addition to the RideSizer report</label>
                    </div>
                </div>
            </form>
        );
    }
}

// REDUX STATES
const mapStateToProps = state => {
    return {
        email: state.user.email,
        date: state.user.date,
        showSubmit: state.flags.showSubmit,
        user: state.user.user,
        params: state.user.params,
        id: state.user.user.id,
        subscription: state.user.subscription,
        bike: state.bike.bike,
        bikeDueDate: state.bike.bikeDueDate,
        estimatedHeight: state.bike.estimatedHeight
    }
};

export default connect(mapStateToProps)(FormEmail);


// WEBPACK FOOTER //
// ./src/components/FormEmail.js